<template>
	<ValidationObserver tag="form" ref="observer" @submit.prevent="handleSubmit()">
	    <p class="f-14 f-m-12 margin-0"><strong>Info Kendaraan</strong></p>
	    <div class="row">
	        <div class="col">
				<div class="form-group mb-0">
					<label class="form-label">Jenis kendaraan</label> 
					<ValidationProvider name="Jenis kendaraan" rules="required" v-slot="{ errors }">
						<v-select v-model="model.type" :options="options" :reduce="options => options.title" label="title" placeholder="Pilih jenis kendaraan" :class="{ 'error': errors[0] }">
							<template slot="option" slot-scope="option">
								<img :src="option.cardImage">
								{{ option.title }}
							</template>
						</v-select>
						<small style="color: red !important;" v-if="errors[0]">{{errors[0]}}</small>
					</ValidationProvider>
				</div>
				<div class="form-group mt-1">
					<label class="form-label">Merek dan Tipe kendaraan</label>
					<ValidationProvider name="Merek" rules="required" v-slot="{ errors }">
						<input type="text" v-model="model.merk" class="form-control" :class="{ 'error': errors[0] }" placeholder="Masukkan merek dan tipe kendaraan">   
						<small style="color: red !important;" v-if="errors[0]">{{errors[0]}}</small>
					</ValidationProvider>
				</div>
	        </div>
	        <div class="col">
				<div class="row">
					<div class="form-group col mt-0 with-flex mr-1 ml-0">
						<label class="form-label">Kapasitas</label>
						<ValidationProvider name="Kapasitas" rules="required|min_value:1" v-slot="{ errors }">
							<input type="text" v-model="model.kapasitas" class="form-control" :class="{ 'error': errors[0] }" placeholder="0 Kg">
							<small style="color: red !important;" v-if="errors[0]">{{errors[0]}}</small>
						</ValidationProvider>  
					</div>
					<div class="form-group col mt-0 with-flex mr-1">
						<label class="form-label">Panjang</label>
						<ValidationProvider name="Panjang" rules="required|min_value:1" v-slot="{ errors }">
							<input type="text" v-model="model.panjang" class="form-control" :class="{ 'error': errors[0] }" placeholder="0 m">
							<small style="color: red !important;" v-if="errors[0]">{{errors[0]}}</small>
						</ValidationProvider>  
					</div>
					<div class="form-group col mt-0 with-flex mr-1">
						<label class="form-label">Lebar</label>
						<ValidationProvider name="Lebar" rules="required|min_value:1" v-slot="{ errors }">
							<input type="text" v-model="model.lebar" class="form-control" :class="{ 'error': errors[0] }" placeholder="0 m">
							<small style="color: red !important;" v-if="errors[0]">{{errors[0]}}</small>
						</ValidationProvider>  
					</div>
					<div class="form-group col mt-0 with-flex mr-0">
						<label class="form-label">Tinggi</label>
						<ValidationProvider name="Tinggi" rules="required|min_value:1" v-slot="{ errors }">
							<input type="text" v-model="model.tinggi" class="form-control" :class="{ 'error': errors[0] }" placeholder="0 m">
							<small style="color: red !important;" v-if="errors[0]">{{errors[0]}}</small>
						</ValidationProvider>  
					</div>
				</div>
				<div class="form-group mr-0">
					<label class="form-label">Nomor polisi</label>
					<ValidationProvider name="Nomor polisi" rules="required" v-slot="{ errors }">
						<input type="text" v-model="model.nopol" class="form-control" :class="{ 'error': errors[0] }" placeholder="Masukkan nomor polisi">
						<small style="color: red !important;" v-if="errors[0]">{{errors[0]}}</small>
					</ValidationProvider>  
				</div>
			</div>    
	    </div>      
	    <hr>

	    <button class="float-right btn btn-primary col-2 mb-3 w-m-1-2 margin-5 pd-10-20">Simpan</button>
	</ValidationObserver>
</template>

<script>
export default {
	name: 'Form',
	data() {
		return {
			options: [
				{					
					title: "Colt Diesel Double (CCD)",
					cardImage: "/img/kendaraan/fuso-ringan.png"
				},
				{					
					title: "Colt Diesel Double (CCD) Long Box",
					cardImage: "/img/kendaraan/fuso-berat-1-1.png"
				},
				{					
					title: "Colt Diesel Engkel (CDE)",
					cardImage: "/img/kendaraan/fuso-ringan_2.png"
				},
				{
					title: "Tronton Box",
					cardImage: "/img/kendaraan/tronton-box.png"
				},
				{					
					title: "Colt Diesel Engkel (CDE) Wing Box",
					cardImage: "/img/kendaraan/fuso-ringan_2.png"
				},
				{					
					title: "Colt Diesel Double (CDD) Wing Box",
					cardImage: "/img/kendaraan/fuso-berat-1-1.png"
				},
				{
					title: "Tronton Wing Box",
					cardImage: "/img/kendaraan/tronton-box.png"
				},
				{
					title: "Fuso",
					cardImage: "/img/kendaraan/fuso-berat-1-1.png"
				},
				{
					title: "Colt Diesel Double (CCD) Bak",
					cardImage: "/img/kendaraan/pickup.png"
				},
				{
					title: "Colt Diesel Double (CCD) Bak Long",
					cardImage: "/img/kendaraan/pickup.png"
				},				
				{
					title: "Jenis Kendaraan Lainnya"
				}
			],
			selectedCountries: [],
			countries: [],
			isLoading: false,
			model: {
				type: null,
				merk: null,
				kapasitas: null,
				panjang: null,
				lebar: null,
				tinggi:null,
				nopol:null
			},
			autoInput: true
		}
	},
	beforeMount() {
		let _ = this

		if ( _.$route.params.id ) {
			_.getData()
		}
	},
	methods: {
		create() {
			let _ = this
			let data = _.model
			_.axios.post('vehicle', data )
				.then(resp => {
					if ( resp.data.status ) {
						_.$router.push({
							name: 'VehicleIndex',
							params: {
								status: 'insert'
							}
						})
					}
				})
				.catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
		},
		update() {
			let _ = this
			let update = {
				id: _.$route.params.id,
				..._.model
			}

			_.axios.patch('/vehicle', update)
				.then(resp => {
					if ( resp.data.status ) {
						_.$router.push({
							name: 'VehicleIndex',
							params: {
								status: 'update'
							}
						})
					}
				})
				.catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
		},
		getData() {
			let _ = this
			_.autoInput = false
			_.axios.get('/vehicle?id=' + _.$route.params.id)
				.then(resp => {
					let getData = resp.data.data.rows
					_.model = {
						type: getData.type,
						merk: getData.merk,
						kapasitas: getData.kapasitas,
						panjang: getData.panjang,
						lebar: getData.lebar,
						tinggi: getData.tinggi,
						nopol: getData.nopol
					}					
				})
				.catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
		},
		async handleSubmit(){
			let _ = this
			const isValid = await this.$refs.observer.validate()
			if (isValid) {
				if (_.$route.params.id){
					_.update()
				} else {
					_.create()
				}
			}
		}
	},
	watch: {
		'model.type': function(){
			let _ = this
			if (_.autoInput){			
				switch (_.model.type) {
					case "Colt Diesel Double (CCD)":
						_.model.kapasitas = 8000 
						_.model.panjang = 4.5 
						_.model.lebar = 2
						_.model.tinggi = 2
						break;

					case "Colt Diesel Double (CCD) Long Box":
						_.model.kapasitas = 14000 
						_.model.panjang = 5.3 
						_.model.lebar = 2.3
						_.model.tinggi = 2.5
						break;

					case "Colt Diesel Engkel (CDE)":
						_.model.kapasitas = 5100 
						_.model.panjang = 3.5 
						_.model.lebar = 1.6
						_.model.tinggi = 1.6
						break;

					case "Tronton Box":
						_.model.kapasitas = 15000 
						_.model.panjang = 6.3 
						_.model.lebar = 2.2
						_.model.tinggi = 2.3
						break;

					case "Colt Diesel Engkel (CDE) Wing Box":
						_.model.kapasitas = 10000 
						_.model.panjang = 7 
						_.model.lebar = 2.2
						_.model.tinggi = 2.5
						break;

					case "Colt Diesel Double (CDD) Wing Box":
						_.model.kapasitas = 18000 
						_.model.panjang = 9.3 
						_.model.lebar = 2.5
						_.model.tinggi = 2.5
						break;

					case "Tronton Wing Box":
						_.model.kapasitas = 25000 
						_.model.panjang = 9.4 
						_.model.lebar = 2.4
						_.model.tinggi = 2.9
						break;

					case "Fuso":
						_.model.kapasitas = 7000 
						_.model.panjang = 5.7 
						_.model.lebar = 2.3
						_.model.tinggi = 2.4
						break;

					case "Colt Diesel Double (CCD) Bak":
						_.model.kapasitas = 8000 
						_.model.panjang = 4.5 
						_.model.lebar = 2
						_.model.tinggi = 2
						break;
					case "Colt Diesel Double (CCD) Bak Long":
						_.model.kapasitas = 14000 
						_.model.panjang = 5.3 
						_.model.lebar = 2.3
						_.model.tinggi = 2.5
						break;
				
					default:
						_.model.kapasitas = 0 
						_.model.panjang = 0 
						_.model.lebar = 0
						_.model.tinggi = 0
						break;
				}
			}
			
			if (_.autoInput == false){
				_.autoInput = true
			}
		}	
	}
}
</script>